import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
import { getUserAndEventTime } from './lib/index.js';
export const createPayrollRunsFetchedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.PAYROLL_RUNS_FETCHED,
        ...getUserAndEventTime(),
        data: {
            uri: 'https://api.atomicfi.com/employers/642c9aa6f8fc90e0dbb4c92f/payroll-runs',
            employerId: '642c9aa6f8fc90e0dbb4c92f',
            validationErrors: [
                {
                    instancePath: '/runState',
                    schemaPath: '#/properties/runState/minLength',
                    keyword: 'minLength',
                    params: {
                        limit: 1
                    },
                    message: 'must NOT have fewer than 1 characters',
                    data: {
                        payPeriodStartDate: '2023-3-1',
                        payPeriodEndDate: '2023-3-31',
                        checkDate: '2023-3-31',
                        runState: ''
                    }
                }
            ]
        }
    };
};
//# sourceMappingURL=payroll-runs-fetched.js.map